import React from "react";
import { useHomeV2Context } from "../context/home_v2_context";
import { ChevronDown } from "lucide-react";

const Accordion = ({ question, answer, isLast }) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const contentRef = React.useRef(null);
  const [contentHeight, setContentHeight] = React.useState(0);

  // Update content height when opened/closed
  React.useEffect(() => {
    if (contentRef.current) {
      setContentHeight(isOpen ? contentRef.current.scrollHeight : 0);
    }
  }, [isOpen]);

  return (
    <div className="w-full">
      <button
        className={`accordion-button flex justify-between items-center w-full py-3 px-4 transition-colors duration-300 hover:bg-slate-900/30 ${
          !isLast ? "border-b border-purple-800/30" : ""
        }`}
        onClick={() => setIsOpen(!isOpen)}
      >
        <h3
          className={`accordion-title text-lg font-medium transition-colors duration-300 ${
            isOpen ? "text-pink-300" : "text-white"
          }`}
        >
          {question}
        </h3>
        <ChevronDown
          size={20}
          className={`transition-transform duration-300 ${
            isOpen ? "rotate-180 text-pink-400" : "text-purple-300"
          }`}
        />
      </button>

      <div
        className="overflow-hidden transition-all duration-300 ease-in-out"
        style={{ height: contentHeight, opacity: isOpen ? 1 : 0 }}
      >
        <div ref={contentRef} className="py-3 px-4">
          <p className="text-pink-200/90">{answer}</p>
        </div>
      </div>
    </div>
  );
};

const FAQComp = () => {
  const { faqItems } = useHomeV2Context();

  return (
    <div id="faq" className="w-full max-w-4xl mx-auto mb-20 pt-8 scroll-mt-20">
      <h2 className="text-3xl font-bold mb-8 text-center text-pink-200 max-sm:text-2xl">
        Frequently Asked Questions
      </h2>

      <div className="bg-slate-950/70 backdrop-blur-sm border border-red-900/20 rounded-xl overflow-hidden">
        {faqItems.map((item, index) => (
          <Accordion
            key={index}
            question={item.question}
            answer={item.answer}
            isLast={index === faqItems.length - 1}
          />
        ))}
      </div>
    </div>
  );
};

export default FAQComp;
